<div class="action-container">
  <div class="balance-overview-actions">
    <button [disabled]="accountClosed" mat-flat-button class="main-action-button" (click)="goToPayment()" color="primary">
      <mat-icon class="material-icons">attach_money</mat-icon>
      <span>NEW PAYMENT</span>
    </button>


    <button mat-stroked-button color="default" class="actions-menu-button" [matMenuTriggerFor]="balanceOverviewMenu">

      <span class="flex align-items-center"><mat-icon class="material-icons">more_vert</mat-icon>ACTIONS<mat-icon class="material-icons">expand_more</mat-icon></span>

    </button>
    <mat-menu #balanceOverviewMenu="matMenu" xPosition="before">
      <!-- <button mat-menu-item (click)="goToDistribution()">
        <mat-icon class="action-icon notranslate">logout</mat-icon>
        <span>New Distribution</span>
      </button> -->
      <button *ngIf="!accountClosed" mat-menu-item (click)="openFundAccountDialog()">
        <mat-icon class="action-icon notranslate material-icons-outlined">savings</mat-icon>
        <span>Fund My Account</span>
      </button>

      <button *ngIf="!accountClosed" mat-menu-item (click)="openCheckDepositDialog()">
        <mat-icon class="action-icon notranslate material-symbols-outlined">checkbook</mat-icon>
        <span>Deposit Check</span>
      </button>

      <button *ngIf="!isGpBankAccount && !accountClosed" (click)="downloadFaqPdf(bankAccount.id)" mat-menu-item>
        <mat-icon class="action-icon notranslate material-icons-outlined psychology-icon">psychology_alt</mat-icon>
        <span>FAQ</span>
      </button>
      <a mat-menu-item [routerLink]="paths.SUPPORT">
        <mat-icon class="action-icon notranslate material-icons-outlined">support_agent</mat-icon>
        <span>Contact Support</span>
      </a>
      <ng-container *ngIf="isGpBankAccount && !accountClosed">
        <button mat-menu-item (click)="toggleDistributionUsage($event)"
        terraCheckPermissions [minimumFinancialPermissionLevel]="financialPermissionLevel.AuthorizedSignatory">
          <mat-icon *ngIf="!bankAccount.isDistributionEnabled" class="action-icon notranslate material-icons-outlined psychology-icon">check_circle</mat-icon>
          <mat-icon *ngIf="bankAccount.isDistributionEnabled" class="action-icon notranslate material-icons-outlined psychology-icon">do_not_disturb_on</mat-icon>
          <span>{{ bankAccount.isDistributionEnabled ? 'Disable ' : 'Enable ' }} distributions</span>
        </button>
      </ng-container>
      <!-- <mat-slide-toggle hideIcon labelPosition="before" [ngModel]="bankAccount.isDistributionEnabled" (change)="toggleDistributionUsage($event)">Enable distributions</mat-slide-toggle> -->
      <button *ngIf="!accountClosed && allowCloseAccount$ | async" mat-menu-item (click)="closeAccountDialog(bankAccount.id)">
        <mat-icon class="action-icon notranslate material-icons-outlined">close</mat-icon>
        <span>Close Account</span>
      </button>
    </mat-menu>
  </div>
</div>
